import { z } from 'zod';
import { requireFields, yesNo, yesNoRequired } from '@utils/form-schema';

export const assessTobaccoSchema = z
    .object({
        hasUsedTobacco: yesNoRequired,
        usesTobacco: yesNo,
        willStopTobaccoUse: yesNo,
    })
    .superRefine((data, ctx) => {
        if (data.hasUsedTobacco !== '1') return;

        requireFields(ctx, data, 'usesTobacco');

        if (data.usesTobacco === '1') {
            requireFields(ctx, data, 'willStopTobaccoUse');
        }
    });
